<template>
  <div
    v-loading="$wait.is('confirmLeadCsvImportTaskWait')"
    class="lead-csv-import-status"
  >
    <ImportStatus
      v-for="task in leadCsvImportTasks"
      :key="task.id"
      :target-task="task"
      :progress-message="$t('import.csv.status.progress')"
      :error-message="$t('import.csv.status.error')"
      :error-modal-title="$t('import.csv.errorTitle')"
      :success-message="$t('import.csv.status.success')"
      @confirm="() => confirmTask(task.id)"
      @success="$emit('success')"
    />
  </div>
</template>

<script>
import { mapWaitingActions } from 'vue-wait';
import { mapGetters } from 'vuex';
import ImportStatus from '@/components/organisms/user/leadImport/ImportStatus.vue';

export default {
  components: {
    ImportStatus,
  },
  emits: [
    'success',
  ],
  computed: {
    ...mapGetters('user', ['leadCsvImportTasks']),
  },
  created() {
    this.getLeadCsvImportTasksAction();
    this.timeObj = this.$setInterval(() => {
      this.getLeadCsvImportTasksAction();
    }, 90000);
  },
  beforeUnmount() {
    this.$clearInterval(this.timeObj);
  },
  methods: {
    ...mapWaitingActions('user', {
      getLeadCsvImportTasksAction: 'getLeadCsvImportTasksWait',
      confirmLeadCsvImportTaskAction: 'confirmLeadCsvImportTaskWait',
    }),
    confirmTask(taskId) {
      this.confirmLeadCsvImportTaskAction({ leadCsvImportTaskId: taskId });
    },
  },
};
</script>

<style scoped lang="scss">
  .import-status:nth-last-child(n + 2) {
    border-bottom: 1px solid $concrete-light;
  }
</style>
